import { transparentImage } from '../globals';

export type ImageLoaderConfig = {
	src: string;
	placeholder?: string;
};

export interface ImageLoaderResult {
	status: string;
	src: string;
}

export function imageLoader({
	src,
	placeholder = transparentImage,
}: ImageLoaderConfig): Promise<ImageLoaderResult> {
	return new Promise((resolve) => {
		const image: HTMLImageElement = new Image();

		function onError() {
			image.removeEventListener('error', onError);
			return resolve({ status: 'error', src: placeholder });
		}

		function onLoad() {
			image.removeEventListener('load', onLoad);
			return resolve({ status: 'success', src });
		}

		image.addEventListener('error', onError);
		image.addEventListener('load', onLoad);
		image.src = src;
	});
}
